import { InnerHTML } from '@headless-workspace/domain/common/client';
import { HTMLString } from '@headless-workspace/domain/common/server';
import { Component } from '@headless-workspace/typings';

type ProductDetailDeliveryInfoProps = {
    deliveryInfo: HTMLString;
};

export const ProductDetailDeliveryInfo: Component<ProductDetailDeliveryInfoProps> = ({ deliveryInfo }) => {
    return (
        <div className="w-full">
            <InnerHTML rawHtml={deliveryInfo} />
        </div>
    );
};
